import React, {  useState } from 'react';
import Menu, { TabType } from './Menu';
import ListAllAthletes from './ListAllAthletes';
import ListUsers from './ListUsers';
import StartList from './StartList';

const LoggedIn = () => {
   
    const [tab, setTab] = useState('all' as TabType);

    return <><Menu sel={tab} onItemSelected={(x) => {setTab(x);}}/>
        {tab == 'all' && <ListAllAthletes />}
        {tab == 'startlist' && <StartList />}
         {tab == 'users' && <ListUsers />}
    </>;
}

export default LoggedIn;